<app-state-section [state]="sectionState">
  <app-modal
    #resetPasswordModal
    [title]="'Inputs.ResetPassword' | translate"
    [subTitle]=" '(' + name + ')' "
    [maxWidth]="500"
    [padding]="20"
    [textColor]="'var(--color-dark)'"
    [applyHeaderStyle]="false"
  >
    <div class="wrapper flex column">
      <mat-divider class="divider"></mat-divider>
      <div class="content">
        <form class="form-group flex column justify-flex-start align-flex-start" [formGroup]="form">
          <!-- new password -->
          <div class="input flex column">
            <mat-label>{{"Inputs.NewPassword" | translate}}</mat-label>
            <mat-form-field appearance="outline" [class.touched]="form.get('password').touched">
              <input
                name="password"
                matInput
                [type]="!displayPassword ? 'password' : 'text'"
                [placeholder]="'Placeholder.EnterYourNewPassword' | translate"
                formControlName="password"
                autocomplete="password"
              />

              <button mat-icon-button matSuffix (click)="displayPassword = !displayPassword">
                <app-icon type="MaterialDesign" [name]="displayPassword ? 'visibility' : 'visibility_off'"></app-icon>
              </button>

              <mat-error *ngIf="form.invalid && form.get('password').touched  && form.get('password').hasError('required')">
                {{ "ErrorMessages.Required" | translate }}
              </mat-error>
              <mat-error *ngIf="form.invalid && form.get('password').touched && form.get('password').hasError('invalidPassword')">
                {{ "ErrorMessages.InvalidPassword" | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- confirm -->
          <div class="input flex column">
            <mat-label>{{ "Inputs.ConfirmNewPassword" | translate}}</mat-label>
            <mat-form-field appearance="outline" [class.touched]="form.get('confirmPassword').touched">
              <input
                matInput
                name="confirmPassword"
                [type]="!displayConfirmPassword ? 'password' : 'text'"
                [placeholder]="'Placeholder.ConfirmYourNewPassword' | translate"
                formControlName="confirmPassword"
                autocomplete="confirmPassword"
              />

              <button mat-icon-button matSuffix (click)="displayConfirmPassword = !displayConfirmPassword">
                <app-icon type="MaterialDesign" [name]=" displayConfirmPassword ? 'visibility' : 'visibility_off'"></app-icon>
              </button>

              <mat-error *ngIf="form.invalid && form.get('confirmPassword').touched && form.get('confirmPassword').hasError('required')">
                {{ "ErrorMessages.Required" | translate }}
              </mat-error>
              <mat-error *ngIf="form.invalid &&  form.get('confirmPassword').touched && form.get('confirmPassword').hasError('notMatch')">
                {{ "ErrorMessages.PasswordsNotMatched" | translate }}
              </mat-error>
              <mat-error *ngIf="form.invalid  &&  form.get('confirmPassword').touched && form.get('confirmPassword').hasError('invalidPassword')">
                {{ "ErrorMessages.InvalidPassword" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </form>
      </div>

      <mat-divider class="divider"></mat-divider>

      <div class="action flex">
        <button mat-raised-button class="btn-secondary btn" (click)="onCancelClicked()">{{ "Buttons.Cancel" | translate }}</button>

        <button [disabled]="form.invalid" mat-raised-button class="btn-primary btn" (click)="onSendClicked()">
          {{ "Buttons.Send" | translate }}
        </button>
      </div>
    </div>
  </app-modal>
</app-state-section>
